import { TODAY } from '@/api/mock/clock';
import { apiMode } from '@/api/mode';

function isoDate(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/** Single source of "now" for the UI. Mock mode uses a fixed date so screenshots and tests are stable; live mode uses the real clock. */
export const clock = {
  today: (): string => (apiMode === 'live' ? isoDate(new Date()) : TODAY),
  now: (): Date => (apiMode === 'live' ? new Date() : new Date(`${TODAY}T10:30:00+05:30`)),
};

/** "Good morning, Kasun": one greeting for every dashboard, so roles do not get different tones. */
export function greeting(firstName: string, now: Date = clock.now()): string {
  const hour = now.getHours();
  return `${hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening'}, ${firstName}`;
}
